export interface Tag {
    displayId: string;
    name: string;
    svgIcon?: string | null;
    backgroundColor?: string | null;
    foregroundColor?: string | null;
    count?: number | null;
}
